<template>
    <div>
        <Cordoba :municipio_id="id" v-if="id == 23" />
    </div>
</template>
<script>
    import axios from 'axios';
    import Cordoba from '../Mapas/Cordoba.vue';

    export default{
        components: {
           Cordoba
        },
        data() {
            return {
                id: 0,
                sedes: []
            }
        },
        mounted() {
            this.id = this.$route.params.id;
        },
        methods: {
            async getSede(){
                /* const res = await axios.get(`/api/sedes/${this.id}`, {
                    headers: {"Authorization": `Bearer ${this.$store.state.user.token}`}
                })
                this.sedes = res.data.sedes || null;
                this.loader = false */
            }
        },
    }
</script>
